import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Box, Button, Calendar, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import EditSVG from '../../assets/images/icons/edit.svg';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import CheckGreenSVG from '../../assets/images/icons/check-green.svg';
import AlertDangerSVG from '../../assets/images/icons/alert-danger.svg';

/*
    - api
*/
import editPassengerProfileAPI from '../../api/edit/PassengerProfile';
import editUserProfileAPI from '../../api/edit/UserProfile';
import sendEmailConfirmCodeAPI from '../../api/add/SendEmailConfirmCode';
import verifyEmailConfirmCodeAPI from '../../api/add/VerifyEmailConfirmCode';

const EditForm = ({ props, alertProps, reloadDashboardProps }) => {

    /*
        - defaultData
    */
    const today = moment().locale('fa').format('YYYY/MM/DD');
    const [citiesAndStates, setCitiesAndStates] = React.useState('empty');
    let states = [];
    let cities = [];
    const [userProfileParameters, setUserProfileParameters] = React.useState({
        firstName: {
            value: '',
            color: 'dark'
        },
        lastName: {
            value: '',
            color: 'dark'
        },
        mobile: {
            value: '',
            color: 'dark'
        },
        email: {
            value: '',
            color: 'dark'
        }
    });
    const [passengerProfileParameters, setPassengerProfileParameters] = React.useState({
        nationalCode: {
            value: '',
            color: 'dark'
        },
        state: {
            value: '',
            color: 'dark'
        },
        city: {
            value: '',
            color: 'dark'
        },
        address: {
            value: '',
            color: 'dark'
        }
    });
    const [passengerProfileBirthdate, setPassengerProfileBirthdate] = React.useState('');
    const [passengerProfileMarriagedate, setPassengerProfileMarriagedate] = React.useState('');
    const [newEmail, setNewEmail] = React.useState({
        value: '',
        color: 'dark'
    });
    const [verifyCode, setVerifyCode] = React.useState('');
    const [confirmId, setConfirmId] = React.useState('');
    const [confirmEmailState, setConfirmEmailState] = React.useState('1');
    const [timer, setTimer] = React.useState(60);
    const [timerStatus, setTimerStatus] = React.useState(true);
    const [emailAlert, setEmailAlert] = React.useState('');
    React.useEffect(() => {
        if (props.userProfile.status === 200) {
            setUserProfileParameters({
                firstName: {
                    value: (props.userProfile.data.firstName !== null) ? props.userProfile.data.firstName : '',
                    color: 'dark'
                },
                lastName: {
                    value: (props.userProfile.data.lastName !== null) ? props.userProfile.data.lastName : '',
                    color: 'dark'
                },
                mobile: {
                    value: (props.userProfile.data.mobile !== null) ? props.userProfile.data.mobile : '',
                    color: 'dark'
                },
                email: {
                    value: (props.userProfile.data.email !== null) ? props.userProfile.data.email : '',
                    color: 'dark'
                }
            });
        }
        if (props.passengerProfile.status === 200) {
            setPassengerProfileParameters({
                nationalCode: {
                    value: (props.passengerProfile.data.nationalCode !== null) ? props.passengerProfile.data.nationalCode : '',
                    color: 'dark'
                },
                state: {
                    value: (props.passengerProfile.data.state !== null) ? props.passengerProfile.data.state : '',
                    color: 'dark'
                },
                city: {
                    value: (props.passengerProfile.data.city !== null) ? props.passengerProfile.data.city : '',
                    color: 'dark'
                },
                address: {
                    value: (props.passengerProfile.data.address !== null) ? props.passengerProfile.data.address : '',
                    color: 'dark'
                }
            });
            setPassengerProfileBirthdate((props.passengerProfile.data.birthDate !== null) ? moment(props.passengerProfile.data.birthDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : '')
            setPassengerProfileMarriagedate((props.passengerProfile.data.marriageDate !== null) ? moment(props.passengerProfile.data.marriageDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : '')
        }
        if (props.citiesAndStates.status === 200) {
            setCitiesAndStates(props.citiesAndStates.data);
        }
    }, [props]);

    if (citiesAndStates !== 'empty') {
        citiesAndStates.forEach((obj) => {
            let helper = {};
            helper.id = obj.id;
            helper.title = obj.title
            states.push(helper);
        });

        citiesAndStates.forEach((parentObj) => {
            states.forEach((childObj) => {
                if (parentObj.id === childObj.id) {
                    parentObj.cities.forEach((grandchildObj) => {
                        grandchildObj.stateId = childObj.id;
                        cities.push(grandchildObj);
                    });
                }
            });
        });
    }

    /*
        - editUserProfileHandler
    */
    const editUserProfileHandler = (key, value) => {
        if (key === 'firstName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
            setUserProfileParameters({
                ...userProfileParameters,
                firstName: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'firstName') {
            setUserProfileParameters({
                ...userProfileParameters,
                firstName: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'lastName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
            setUserProfileParameters({
                ...userProfileParameters,
                lastName: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'lastName') {
            setUserProfileParameters({
                ...userProfileParameters,
                lastName: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'mobile' && (value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(value))) {
            setUserProfileParameters({
                ...userProfileParameters,
                mobile: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'mobile') {
            setUserProfileParameters({
                ...userProfileParameters,
                mobile: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'email') {
            setUserProfileParameters({
                ...userProfileParameters,
                email: {
                    value: value,
                    color: 'dark'
                }
            });
        }
    }

    /*
        - editUserProfile
    */
    const editUserProfile = async () => {
        let parameters = {};
        let isValid = 1;
        if (userProfileParameters.firstName.value === '' || !/^[آ-ی ]+$/.test(userProfileParameters.firstName.value)) {
            setUserProfileParameters({
                ...userProfileParameters,
                firstName: {
                    value: userProfileParameters.firstName.value,
                    color: 'danger',
                    isValid: false
                }
            });
            isValid = 0
        }
        if (userProfileParameters.lastName.value === '' || !/^[آ-ی ]+$/.test(userProfileParameters.lastName.value)) {
            setUserProfileParameters({
                ...userProfileParameters,
                lastName: {
                    value: userProfileParameters.lastName.value,
                    color: 'danger',
                    isValid: false
                }
            });
            isValid = 0
        }
        if (userProfileParameters.mobile.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(userProfileParameters.mobile.value)) {
            setUserProfileParameters({
                ...userProfileParameters,
                mobile: {
                    value: userProfileParameters.mobile.value,
                    color: 'danger',
                    isValid: false
                }
            });
            isValid = 0
        }
        if (isValid === 1) {
            parameters.firstName = userProfileParameters.firstName.value;
            parameters.lastName = userProfileParameters.lastName.value;
            parameters.mobile = userProfileParameters.mobile.value;
            parameters.email = userProfileParameters.email.value;
            let result = await editUserProfileAPI(parameters);
            if (result === 'success') {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadDashboardProps(Math.floor(Math.random() * 100));
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
        }
    }

    /*
        - editPassengerProfileHandler
    */
    const editPassengerProfileHandler = (key, value) => {
        if (key === 'nationalCode' && (value.length !== 10 || !/^[\u06F0-\u06F90-9]+$/.test(value))) {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                nationalCode: {
                    value: value,
                    color: 'danger'
                }
            });
        } else {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                nationalCode: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'state') {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                state: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'city') {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                city: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'address') {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                address: {
                    value: value,
                    color: 'dark'
                }
            });
        }
    }

    /*
        - editPassengerProfile
    */
    const editPassengerProfile = async () => {
        let parameters = {};
        let isValid = 1;
        if (passengerProfileParameters.nationalCode.value.length !== 10 || !/^[\u06F0-\u06F90-9]+$/.test(passengerProfileParameters.nationalCode.value)) {
            setPassengerProfileParameters({
                ...passengerProfileParameters,
                nationalCode: {
                    value: passengerProfileParameters.nationalCode.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.nationalCode = passengerProfileParameters.nationalCode.value;
            parameters.birthDate = (passengerProfileBirthdate !== '') ? moment.from(passengerProfileBirthdate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
            parameters.marriageDate = (passengerProfileMarriagedate !== '') ? moment.from(passengerProfileMarriagedate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
            parameters.state = passengerProfileParameters.state.value;
            parameters.city = passengerProfileParameters.city.value;
            parameters.address = passengerProfileParameters.address.value;
            let result = await editPassengerProfileAPI(parameters);
            if (result === 'success') {
                closeModal('passengerProfileModal');
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadDashboardProps(Math.floor(Math.random() * 100));
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
        }
    }

    /*
        - newEmailHandler
    */
    const newEmailHandler = (email) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            setNewEmail({
                ...newEmail,
                value: email,
                color: 'dark'
            });
        } else {
            setNewEmail({
                ...newEmail,
                value: email,
                color: 'danger'
            });
        }
    }

    /*
        - sendEmailConfirmCode
    */
    const sendEmailConfirmCode = async () => {
        let parameters = {};
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(newEmail.value)) {
            parameters.Email = newEmail.value;
            let result = [];
            result = await sendEmailConfirmCodeAPI(parameters);
            if (result.status === 200) {
                setConfirmId(result.data.Id);
                setConfirmEmailState('2');
                setEmailAlert('');
                let helper = 60;
                if (timerStatus === true) {
                    let interval = setInterval(() => {
                        if (helper !== 0) {
                            helper = helper - 1;
                            setTimer(helper);
                        } else {
                            setTimer(0);
                            clearInterval(interval);
                            setTimerStatus(true);
                        }
                    }, 1000);
                }
            } else {
                setNewEmail({
                    ...newEmail,
                    value: newEmail.value,
                    color: 'danger'
                });
            }
        }
    }

    /*
        - verifyEmailConfirmCode
    */
    const verifyEmailConfirmCode = async () => {
        let parameters = {};
        parameters.Id = confirmId;
        parameters.VerifyCode = verifyCode;
        let result = await verifyEmailConfirmCodeAPI(parameters);
        if (result.status === 200) {
            setConfirmEmailState('3');
        } else {
            if (result.data.Code === 12) {
                setEmailAlert('کد تایید اشتباه است.');
            }
            if (result.data.Code === 13) {
                setEmailAlert('کد تایید منقضی شده است.');
            }
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
        setConfirmEmailState('1');
        setNewEmail('');
        setVerifyCode('');
        setConfirmId('');
        setEmailAlert('');
        setTimerStatus(false);
        reloadDashboardProps(Math.floor(Math.random() * 100));
    }

    /*
        - toggleCaldendar
    */
    const toggleCaldendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'birthdateCalendar') {
            setPassengerProfileBirthdate('')
        }
        if (event.target.tagName === 'INPUT' && calendar === 'marriageDateCalendar') {
            setPassengerProfileMarriagedate('')
        }
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    return (
        <React.Fragment>
            <Box
                className={`p-xl bg-white border-solid border-light rounded-lg`}
                component='form'>
                <Typography
                    className={`my-lg mt-0`}
                    component='p'>
                    در صورت نیاز به تغییر اطلاعات، از طریق این فرم اقدام نمایید.
                </Typography>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <TextField
                                onChange={(event) => editUserProfileHandler('firstName', event)}
                                variant='filled'
                                color={userProfileParameters.firstName.color}
                                label='نام *'
                                icon={EditSVG}
                                placeholder='نام به فارسی'
                                value={userProfileParameters.firstName.value} />
                        </Grid.Item>
                        <Grid.Item
                            size='col-12'>
                            <TextField
                                onChange={(event) => editUserProfileHandler('lastName', event)}
                                variant='filled'
                                color={userProfileParameters.lastName.color}
                                label='نام خانوادگی *'
                                icon={EditSVG}
                                placeholder='نام خانوادگی به فارسی'
                                value={userProfileParameters.lastName.value} />
                        </Grid.Item>
                        <Grid.Item
                            size='col-12'>
                            <TextField
                                onChange={(event) => editUserProfileHandler('mobile', event)}
                                variant='filled'
                                color={userProfileParameters.mobile.color}
                                label='تلفن همراه *'
                                icon={EditSVG}
                                placeholder='09xxxxxxxxxx'
                                value={userProfileParameters.mobile.value}
                                readonly />
                        </Grid.Item>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                onClick={() => openModal('emailConfirmModal')}>
                                <TextField
                                    onChange={(event) => editUserProfileHandler('email', event)}
                                    variant='filled'
                                    color={userProfileParameters.email.color}
                                    label='ایمیل'
                                    icon={EditSVG}
                                    placeholder='youremail@iho.com'
                                    value={userProfileParameters.email.value}
                                    ms={{
                                        'input': {
                                            cursor: 'pointer'
                                        }
                                    }} />
                            </Box>
                        </Grid.Item>
                        <Grid.Item
                            className={`d-flex pb-0`}
                            size='col-12 lg-6'>
                            <Button
                                onClick={editUserProfile}
                                className={`w-25`}
                                variant='filled'
                                color='primary'>
                                تایید
                            </Button>
                            <Button
                                onClick={() => openModal('passengerProfileModal')}
                                className={`w-75 mx-lg ml-0`}
                                variant='outlined'
                                color='primary'>
                                اطلاعات تکمیلی
                            </Button>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Box>
            <Modal
                className={`emailConfirmModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    {confirmEmailState === '1' &&
                        <React.Fragment>
                            {userProfileParameters.email.value !== '' &&
                                <Modal.Header
                                    className={`border-solid-bottom border-light`}>
                                    تغییر ایمیل
                                    <Box />
                                </Modal.Header>
                            }
                            {userProfileParameters.email.value === '' &&
                                <Modal.Header
                                    className={`border-solid-bottom border-light`}>
                                    ثبت ایمیل
                                    <Box />
                                </Modal.Header>
                            }
                            <Box
                                className={`my-md mt-0`} />
                            {userProfileParameters.email.value !== '' &&
                                <Typography>
                                    ایمیل جایگزین {userProfileParameters.email.value} را وارد نمایید.
                                </Typography>
                            }
                            {userProfileParameters.email.value === '' &&
                                <Typography>
                                    ایمیل خود را وارد نمایید.
                                </Typography>
                            }
                            {emailAlert !== '' &&
                                <React.Fragment>
                                    <Box
                                        className={`my-sm`} />
                                    <Box
                                        className={`d-flex`}
                                        ms={{
                                            gap: 'var(--sizing-xs)'
                                        }}>
                                        <Image
                                            src={AlertDangerSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        <Typography
                                            className={`d-block`}
                                            component='strong'
                                            ms={{
                                                color: 'var(--red-medium)'
                                            }}>
                                            {emailAlert}
                                        </Typography>
                                    </Box>
                                </React.Fragment>
                            }
                            <Box
                                className={`my-sm`} />
                            <TextField
                                onChange={(value) => newEmailHandler(value)}
                                variant='filled'
                                color={newEmail.color}
                                label='ایمیل'
                                placeholder='youremail@iho.com'
                                value={newEmail.value} />
                            <Box
                                className={`my-xl`} />
                            <Box
                                className={`d-flex`}>
                                {userProfileParameters.email.value !== '' &&
                                    <Button
                                        onClick={sendEmailConfirmCode}
                                        className={`w-25`}
                                        color='primary'>
                                        تغییر ایمیل
                                    </Button>
                                }
                                {userProfileParameters.email.value === '' &&
                                    <Button
                                        onClick={sendEmailConfirmCode}
                                        className={`w-25`}
                                        color='primary'>
                                        ثبت ایمیل
                                    </Button>
                                }
                                <Box
                                    className={`mx-sm`} />
                                <Button
                                    onClick={() => closeModal('emailConfirmModal')}
                                    className={`w-25`}
                                    variant='outlined'
                                    color='primary'>
                                    بستن
                                </Button>
                            </Box>
                        </React.Fragment>
                    }
                    {confirmEmailState === '2' &&
                        <React.Fragment>
                            <Modal.Header
                                className={`border-solid-bottom border-light`}>
                                کد تایید
                                <Box />
                            </Modal.Header>
                            <Box
                                className={`my-md mt-0`} />
                            <Typography>
                                کد 6 رقمی ارسال شده به ایمیل {newEmail.value} را وارد نمایید.
                            </Typography>
                            {emailAlert !== '' &&
                                <React.Fragment>
                                    <Box
                                        className={`my-sm`} />
                                    <Box
                                        className={`d-flex`}
                                        ms={{
                                            gap: 'var(--sizing-xs)'
                                        }}>
                                        <Image
                                            src={AlertDangerSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        <Typography
                                            className={`d-block`}
                                            component='strong'
                                            ms={{
                                                color: 'var(--red-medium)'
                                            }}>
                                            {emailAlert}
                                        </Typography>
                                    </Box>
                                </React.Fragment>
                            }
                            <Box
                                className={`my-sm`} />
                            <TextField
                                onChange={(value) => setVerifyCode(value)}
                                variant='filled'
                                color='dark'
                                placeholder='کد 6 رقمی'
                                value={verifyCode} />
                            <Box
                                className={`my-sm`} />
                            <Box
                                className={`d-flex justify-content-end`}
                                ms={{
                                    gap: 'var(--sizing-xs)'
                                }}>
                                {timer === 0 &&
                                    <React.Fragment>
                                        <Typography
                                            component='small'>
                                            کد ارسال نشده است؟
                                        </Typography>
                                        <Typography
                                            onClick={sendEmailConfirmCode}
                                            className={`text-primary pointer`}
                                            component='small'>
                                            ارسال مجدد
                                        </Typography>
                                    </React.Fragment>
                                }
                                {timer !== 0 &&
                                    <React.Fragment>
                                        <Typography
                                            component='small'>
                                            زمان انتظار برای درخواست دوباره کد :
                                        </Typography> <Typography
                                            onClick={sendEmailConfirmCode}
                                            className={`text-primary pointer`}
                                            component='small'>
                                            {timer}
                                        </Typography>
                                    </React.Fragment>
                                }
                            </Box>
                            <Box
                                className={`my-xl`} />
                            <Box
                                className={`d-flex`}>
                                <Button
                                    onClick={verifyEmailConfirmCode}
                                    className={`w-25`}
                                    color='primary'>
                                    تایید کد
                                </Button>
                                <Box
                                    className={`mx-sm`} />
                                <Button
                                    onClick={() => closeModal('emailConfirmModal')}
                                    className={`w-25`}
                                    variant='outlined'
                                    color='primary'>
                                    بستن
                                </Button>
                            </Box>
                        </React.Fragment>
                    }
                    {confirmEmailState === '3' &&
                        <React.Fragment>
                            {userProfileParameters.email.value !== '' &&
                                <Modal.Header
                                    className={`border-solid-bottom border-light`}>
                                    تغییر ایمیل
                                    <Box />
                                </Modal.Header>
                            }
                            {userProfileParameters.email.value === '' &&
                                <Modal.Header
                                    className={`border-solid-bottom border-light`}>
                                    ثبت ایمیل
                                    <Box />
                                </Modal.Header>
                            }
                            <Box
                                className={`my-md mt-0`} />
                            <Box
                                className={`d-flex align-item-center`}
                                ms={{
                                    gap: 'var(--sizing-sm)'
                                }}>
                                <Image
                                    src={CheckGreenSVG}
                                    ms={{
                                        width: '32px',
                                        height: '32px'
                                    }} />
                                {userProfileParameters.email.value !== '' &&
                                    <Typography
                                        className={`text-success`}
                                        component='h4'>
                                        تغییر ایمیل با موفقیت انجام شد.
                                    </Typography>
                                }
                                {userProfileParameters.email.value === '' &&
                                    <Typography
                                        className={`text-success`}
                                        component='h4'>
                                        ثبت ایمیل با موفقیت انجام شد.
                                    </Typography>
                                }
                            </Box>
                            <Box
                                className={`my-md`} />
                            <Box
                                className={`d-block`}
                                ms={{
                                    paddingRight: '42px'
                                }}>
                                {userProfileParameters.email.value !== '' &&
                                    <React.Fragment>
                                        ایمیل جدید : <Typography
                                            className={`text-bold`}>
                                            {newEmail.value}
                                        </Typography>
                                    </React.Fragment>
                                }
                                {userProfileParameters.email.value === '' &&
                                    <React.Fragment>
                                        ایمیل شما : <Typography
                                            className={`text-bold`}>
                                            {newEmail.value}
                                        </Typography>
                                    </React.Fragment>
                                }
                            </Box>
                            <Box
                                className={`my-xl`} />
                            <Box
                                className={`d-flex`}>
                                <Button
                                    onClick={() => closeModal('emailConfirmModal')}
                                    className={`w-25`}
                                    variant='outlined'
                                    color='primary'>
                                    بستن
                                </Button>
                            </Box>
                        </React.Fragment>
                    }
                </Modal.Wrapper>
            </Modal>
            <Modal
                className={`passengerProfileModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        اطلاعات تکمیلی
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Typography
                        className={`px-lg`}>
                        می توانید اطلاعات تکمیلی پروفایل خود را ویرایش نمایید
                    </Typography>
                    <Box
                        component='form'>
                        <Grid>
                            <Grid.Wrapper
                                className={`px-sm`}>
                                <Grid.Item
                                    size='col-12 md-4'>
                                    <TextField
                                        onChange={(event) => editPassengerProfileHandler('nationalCode', event)}
                                        color={passengerProfileParameters.nationalCode.color}
                                        label='کد ملی *'
                                        icon={EditSVG}
                                        value={passengerProfileParameters.nationalCode.value} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`position-relative`}
                                    size='col-12 md-4'>
                                    <Box
                                        onClick={(event) => toggleCaldendar(event, 'birthdateCalendar')}>
                                        <TextField
                                            label='تاریخ تولد'
                                            icon={CalendarSVG}
                                            value={passengerProfileBirthdate} />
                                        <Box
                                            className={`d-none calendar birthdateCalendar position-absolute`}
                                            ms={{
                                                width: '320px',
                                                top: '80px',
                                                zIndex: '1'
                                            }}>
                                            <Calendar
                                                onChange={(event) => setPassengerProfileBirthdate(event)}
                                                maxDate={today} />
                                        </Box>
                                    </Box>
                                </Grid.Item>
                                <Grid.Item
                                    className={`position-relative`}
                                    size='col-12 md-4'>
                                    <Box
                                        onClick={(event) => toggleCaldendar(event, 'marriageDateCalendar')}>
                                        <TextField
                                            label='تاریخ ازدواج'
                                            icon={CalendarSVG}
                                            value={passengerProfileMarriagedate} />
                                        <Box
                                            className={`d-none calendar marriageDateCalendar position-absolute`}
                                            ms={{
                                                width: '320px',
                                                top: '80px',
                                                zIndex: '1'
                                            }}>
                                            <Calendar
                                                onChange={(event) => setPassengerProfileMarriagedate(event)}
                                                maxDate={today} />
                                        </Box>
                                    </Box>
                                </Grid.Item>
                                <Grid.Item
                                    size='col-6'>
                                    <Select
                                        onChange={(event) => editPassengerProfileHandler('state', event)}
                                        color={passengerProfileParameters.state.color}
                                        label='استان'
                                        search
                                        init={passengerProfileParameters.state.value}
                                        readonly>
                                        {states.map((obj, index) => {
                                            return (
                                                <Select.Item
                                                    key={index}
                                                    value={obj.id}>
                                                    {obj.title}
                                                </Select.Item>
                                            )
                                        })}
                                    </Select>
                                </Grid.Item>
                                <Grid.Item
                                    size='col-6'>
                                    <Select
                                        onChange={(event) => editPassengerProfileHandler('city', event)}
                                        color={passengerProfileParameters.city.color}
                                        label='شهر'
                                        search
                                        init={passengerProfileParameters.city.value}
                                        readonly>
                                        {cities.map((obj, index) => {
                                            return (
                                                <React.Fragment
                                                    key={index}>
                                                    {obj.stateId === +passengerProfileParameters.state.value &&
                                                        <Select.Item
                                                            value={obj.id}>
                                                            {obj.title}
                                                        </Select.Item>
                                                    }
                                                </React.Fragment>
                                            )
                                        })}
                                    </Select>
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={(event) => editPassengerProfileHandler('address', event)}
                                        color={passengerProfileParameters.address.color}
                                        label='آدرس'
                                        placeholder='بلوار جانباز - ایران هتل آنلاین'
                                        icon={EditSVG}
                                        value={passengerProfileParameters.address.value} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex`}
                                    size='col-12 md-6'>
                                    <Button
                                        onClick={editPassengerProfile}
                                        className={`w-25`}
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('passengerProfileModal')}
                                        className={`w-25`}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment >
    );

}

export default EditForm;